module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_3-16fd0811e14a70d79c6d73f6639ee653.jpg";